<template>
  <div class="custom-Add">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="名称：" prop="madeName">
        <el-input v-model="form.madeName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="详细内容：" prop="madeContent">
        <editor
          :disabled="true"
          :editContent="form.madeContent"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getPersonalMade } from '@/api/goods';
import Editor from '@/components/Editor';

export default {
  data() {
    return {
      form: {
        madeName: '',
        madeContent: '',
      },
    };
  },
  components: {
    Editor,
  },
  mounted() {
    this.getPersonalMade();
  },
  methods: {
    getPersonalMade() {
      const { id } = this.$route.query;
      getPersonalMade(id).then((res) => {
        if (res.success) {
          const { madeName, madeContent } = res.data;
          this.form.madeName = madeName;
          this.form.madeContent = madeContent;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.custom-Add
  padding-top 100px
  .el-form
    width 910px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0!important
    .submit
      margin-top 100px
      text-align center
</style>
